import React from 'react';
import { ExtendedContentContainer } from 'components/ExtendedContent/ExtendedContentContainer';
import VocabularyExample from 'components/VocabularyExample';

export const VocabularyModalComponent = ({ vocabularyResource, word }) => {
    return <ExtendedContentContainer>
        <VocabularyExample data={vocabularyResource} defaultWord={word}/>
    </ExtendedContentContainer>
};
